import { IconButtonHoverStyle, IconButtonKind } from "./IconButton";
import styles from "./IconButton.module.less";

export const iconButtonKindToStyles: { [key in IconButtonKind]: string } = {
	["primary"]: styles.render_primary,
	["secondary"]: styles.render_secondary,
	["dashed"]: styles.render_dashed,
	["transparent"]: styles.render_transparent,
	["transparent-colored"]: styles.render_transparentColored,
	["gradient"]: styles.render_gradient
};

type HoverStyleMapping = { [key in IconButtonHoverStyle]: string | undefined; };

export const iconButtonHoverStyleToTransparentDefaultStyles: HoverStyleMapping = {
	["default"]: styles.root_hoverStyleTransparent,
	["inversed"]: styles.root_hoverStyleTransparentInversed
};

export const iconButtonHoverStyleToStyles: HoverStyleMapping = {
	["default"]: styles.root_hoverStyleDefault,
	["inversed"]: styles.root_hoverStyleInversed
};

export const iconButtonHoverStyleToTransparentColoredStyles: HoverStyleMapping = {
	["default"]: styles.root_hoverStyleTransparentColored,
	["inversed"]: styles.root_hoverStyleTransparentColoredInversed
};

export const kindToHoverStyleMapping: { [key in IconButtonKind]: HoverStyleMapping; } = {
	["primary"]: iconButtonHoverStyleToStyles,
	["secondary"]: iconButtonHoverStyleToStyles,
	["dashed"]: iconButtonHoverStyleToStyles,
	["transparent"]: iconButtonHoverStyleToTransparentDefaultStyles,
	["transparent-colored"]: iconButtonHoverStyleToTransparentColoredStyles,
	["gradient"]: iconButtonHoverStyleToStyles
};
